import Vue from 'vue';
export var State = new Vue();


// WEBPACK FOOTER //
// ./src/state.js